export const SNAPSHOT_PLUGIN_UPLOAD_EXTRACTOR_PHP = `<?php
$zip = new ZipArchive();
$open_result = $zip->open('/tmp/snapshot.zip');
if ($open_result !== true) {
  error_log('[Blueprint] Failed to open snapshot ZIP: ' . $open_result);
  exit(1);
}

$extracted = 0;
$failures = array();
$prefixes = array(
  'wp-content/uploads/',
  'wp-content/plugins/',
  'wp-content/mu-plugins/',
);

for ($i = 0; $i < $zip->numFiles; $i++) {
  $name = $zip->getNameIndex($i);
  if (!is_string($name) || $name === '') {
    $failures[] = 'invalid-entry-name:' . $i;
    continue;
  }

  if (strpos($name, '..') !== false || strpos($name, chr(0)) !== false) {
    continue;
  }

  $allowed = false;
  foreach ($prefixes as $prefix) {
    if (strpos($name, $prefix) === 0) {
      $allowed = true;
      break;
    }
  }
  if (!$allowed) {
    continue;
  }

  // Miles is reinstalled from a fresh ZIP after import. Avoid loading an
  // older bundled copy during the post-import fixup PHP step.
  if (
    strpos($name, 'wp-content/plugins/miles/') === 0 ||
    strpos($name, 'wp-content/plugins/miles-plugin/') === 0 ||
    strpos($name, 'wp-content/mu-plugins/miles-') === 0
  ) {
    continue;
  }

  if (substr($name, -1) === '/') {
    continue;
  }

  $contents = $zip->getFromIndex($i);
  if ($contents === false) {
    $failures[] = 'read:' . $name;
    continue;
  }

  $targetPath = '/wordpress/' . $name;
  $dir = dirname($targetPath);
  if (!is_dir($dir) && !mkdir($dir, 0777, true) && !is_dir($dir)) {
    $failures[] = 'mkdir:' . $dir;
    continue;
  }

  $bytes = file_put_contents($targetPath, $contents);
  if ($bytes === false) {
    $failures[] = 'write:' . $name;
    continue;
  }

  $extracted++;
}

$zip->close();
if (file_exists('/tmp/snapshot.zip') && !unlink('/tmp/snapshot.zip')) {
  error_log('[Blueprint] Failed to remove temporary snapshot ZIP');
}

if (!empty($failures)) {
  foreach (array_slice($failures, 0, 20) as $failure) {
    error_log('[Blueprint] Snapshot extraction failure: ' . $failure);
  }
  error_log('[Blueprint] Failed to extract ' . count($failures) . ' plugin/upload files from snapshot ZIP');
  exit(1);
}

error_log("[Blueprint] Extracted $extracted plugin/upload files from snapshot ZIP");
`;
